<script setup>

import { ref, onMounted, defineEmits, defineProps, watch, computed } from "vue";
import ERP from "../../../api/v2/ERP.mjs";
import View from "../../../api/v2/View.mjs";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "pagamentosEletronicos",
    "visualizandoPagamentoEletronico",
    "controlesDesativados",
]);

const emits = defineEmits([
    "update:pagamentosEletronicos",
    "update:controlesDesativados"
]);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    emits('update:controlesDesativados',update);

};

//==================================================================//
//=========== Altera Visualizando Pagamento Eletronico =============//
//==================================================================//

const alteraVisualizandoPagamentoEletronico = (update)=>{

    emits('update:visualizandoPagamentoEletronico',update);

};

//==================================================================//
//================ Altera Pagamentos Eletronicos ===================//
//==================================================================//

const alteraPagamentosEletronicos = (update)=>{

    emits('update:pagamentosEletronicos',update);

};

//==================================================================//
//================= Pagamentos Eletronicos Loading =================//
//==================================================================//

const pagamentosEletronicosLoading = ref(true);


//==================================================================//
//========================== Busca Tipo ============================//
//==================================================================//

const buscaTipoPagamentosEletronicos = computed(()=>{

    return props?.pagamentosEletronicos?.map(({tipo})=>tipo);

});
let buscaTipoPagamentosEletronicosSelecionado = ref("");

//==================================================================//
//=============== Filter Tipo Pagamentos Eletronicos ===============//
//==================================================================//

const filterTipoPagamentosEletronicos = (tipoSelecionado) =>{

    if(!buscaTipoPagamentosEletronicosSelecionado.value){
        return true;
    }

    return tipoSelecionado.toLowerCase().includes(buscaTipoPagamentosEletronicosSelecionado.value.toLowerCase());

}

//==================================================================//
//================= Pagamentos Eletronicos Header ==================//
//==================================================================//

let pagamentosEletronicosHeaders = [
    { text: '',                      value: 'visualizar',    class:"c-pedido__header",   cellClass:'c-pedido__cell', width: "80px"},
    { text: 'Tipo',                  value: 'tipo',          class:"c-pedido__header",   cellClass:'c-pedido__cell', filter: filterTipoPagamentosEletronicos},
    { text: 'Filial',                value: 'filial.codigo', class:"c-pedido__header",   cellClass:'c-pedido__cell'},
    { text: 'Status',                value: 'status',        class:"c-pedido__header",   cellClass:'c-pedido__cell'},
    { text: 'Pagamento Eletrônico',  value: 'codigo',        class:"c-pedido__header",   cellClass:'c-pedido__cell'},
    { text: 'Data Criação',          value: 'dataCriacao',   class:"c-pedido__header",   cellClass:'c-pedido__cell'},
    { text: 'Descrição',             value: 'descricao',     class:"c-pedido__header",   cellClass:'c-pedido__cell'},
]

//==================================================================//
//============ Ao Visualizar Pagamentos Eletronicos ================//
//==================================================================//

const aoVisualizarPagamentosEletronicos = (item)=>{

    alteraVisualizandoPagamentoEletronico({
        visualizandoPagamentoEletronico: true,
        pagamentoEletronico: item
    });

}

//==================================================================//
//================== Load Pagamentos Eletronicos ==================//
//==================================================================//

const loadPagamentosEletronicos = async () =>{

    pagamentosEletronicosLoading.value = true;
    alteraControlesDesativados(true);

    const paramentosEletronicosResponse = await ERP.getManyWithView(View.PAGAMENTOS_ELETRONICOS_VISUALIZAR_PAGAMENTOS_ELETRONICOS);
    
    alteraPagamentosEletronicos(paramentosEletronicosResponse.data)

    alteraControlesDesativados(false);
    pagamentosEletronicosLoading.value = false;

};

//==================================================================//
//============================ onMounted ===========================//
//==================================================================//

onMounted(async ()=>{

    await loadPagamentosEletronicos();

});

//==================================================================//
//============================== Watch =============================//
//==================================================================//

watch(()=> props.visualizandoPagamentoEletronico, () => {

    if(props.visualizandoPagamentoEletronico == false){
        loadPagamentosEletronicos();
    }

});

</script>

<template>

    <v-card
        class="c-lista-de-pagamentos-eletronicos"
    >

        <v-card-title
            class="c-lista-de-pagamentos-eletronicos__header"
        >

            <div
                class="c-header__buscas"
            >

                <div class="c-busca c-busca--select c-busca--tipo-do-pagamento-eletronico">

                    <v-select
                        label="Tipo do Pagamento"
                        class="c-busca__input"
                        v-model="buscaTipoPagamentosEletronicosSelecionado"
                        :items="buscaTipoPagamentosEletronicos"
                        :item-props="true"
                        :disabled="props.controlesDesativados"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                    ></v-select>

                </div>

            </div>

            <v-chip
                class="c-header__usuario"
                label
            >

                <v-icon left>
                    mdi-account-circle-outline
                </v-icon>
                Usuario:
                {{colaboradorStore.colaborador.nome}}

            </v-chip>

        </v-card-title>

        <v-data-table
            class="c-lista-de-pagamentos-eletronicos__tabela elevation-1"
            :headers="pagamentosEletronicosHeaders"
            :items="props.pagamentosEletronicos"
            :items-per-page="-1"
            select-strategy="all"
            item-key="id"
            return-object
            :loading="pagamentosEletronicosLoading"
            loading-text="Carregando... Por favor, aguarde."
        >

            <template v-slot:item.visualizar="{ item }">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            class="c-visualizar-pagamento-eletronico mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoVisualizarPagamentosEletronicos(item)"
                            :disabled="props.controlesDesativados"
                        >

                            <v-icon dark>
                                mdi-eye
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Visualizar o Pagamento Eletrônico</span>

                </v-tooltip>

            </template>

        </v-data-table>

    </v-card>

</template>

<style scoped>

.c-lista-de-pagamentos-eletronicos__header{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: auto; 
    grid-template-areas: 
    "buscas usuario";
    gap: 10px;
    align-items: start;
}


.c-header__buscas{
    grid-area: buscas;
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px;
    grid-template-areas: 
        "buscaTipoPagamentoEletronico";
}

.c-busca > .c-busca__texto{
    margin: 0;
    font-size: 14px;
}

.c-busca--toogle{
    align-items: center;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
}

.c-busca--toogle > .c-busca__input{
    padding-left: 10px;
}

.c-busca--tipo-do-pagamento-eletronico{
    grid-area: buscaTipoPagamentoEletronico;
}

.c-header__usuario{
    grid-area: usuario;
    margin: 0 20px;
    min-height: 48px;
}

.c-header__usuario >>> .v-chip__content{
    margin: auto;
}

.c-lista-de-pedidos__tabela{
    display: grid;
    white-space: nowrap;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-visualizar-pagamento-eletronico{
    background: #1976d2 !important;
    border-color: #1976d2 !important;
}

@media (width <= 850px) {
    
    .c-lista-de-pagamentos-eletronicos__header{
        grid-template-columns: 1fr; 
        grid-template-rows: auto auto; 
        grid-template-areas:
            "usuario"
            "buscas";
    }

    .c-header__usuario{
        margin: 0;
    }

    .c-header__buscas { 
        grid-area: buscas;
        display: grid; 
        grid-template-columns: 1fr; 
        grid-template-rows: 1fr; 
        gap: 10px; 
        grid-template-areas: 
            "buscaTipoPagamentoEletronico";
    }

}

</style>
